export default "__VITE_ASSET__GxzX5zj8__"